<template>
    <el-container>
        <el-table :data="tableData" :span-method="spanMethod" header-align="center" border>
            <el-table-column show-overflow-tooltip :label="$t('nav.plant')" prop="plantName" width="300" ></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('sensory.report.batchNo')" prop="batchNo"></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('sensory.calibration.user')" prop="userName"></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('sensory.calibration.project')" prop="project"></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('sensory.calibration.spScore')" prop="spScore"></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('sensory.calibration.cqsScore')" prop="cqsScore"></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('sensory.calibration.singleScore')" prop="singleScore"></el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('sensory.calibration.calibtrateScore')" prop="calibtrateScore"></el-table-column>
        </el-table>
    </el-container>
</template>

<script>
    import commonFun from "@/utils/commonFun";

    export default {
        name: "analysisDetails",
        props: {
            analysisDetails: {
                type: Object,
                default: []
            },
        },
        data() {
            return  {
                tableData: []
            }
        },
        watch: {
            analysisDetails(newValue, oldValue) {
                this.initData();
            }
        },
        created() {
            this.initData();
        },
        methods: {
            spanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex <= 2 || columnIndex == 7) {
                    if (row.projectIndex == 0) {
                        return [row.rowSpan,1];
                    } else {
                        return [0, 0];
                    }
                }
            },
            initData() {
                let tableData = [];
                if (commonFun.isEmpty(this.analysisDetails)) {
                    return;
                }
                this.analysisDetails.forEach(detail=>{
                    detail.projectList.forEach((project,index)=>{
                        let row = {};
                        row.projectIndex = index;
                        row.plantName = detail.plantName;
                        row.batchNo = detail.batchNo;
                        row.userName = detail.userName;
                        row.rowSpan = detail.projectList.length;
                        row.project = project.project;
                        if (row.project.includes("分数")) {
                            commonFun.isNotEmpty(project.spScore) ? (row.spScore = project.spScore + "%") : '';
                            commonFun.isNotEmpty(project.cqsScore) ? (row.cqsScore = project.cqsScore + "%") : '';
                        } else {
                            row.spScore = project.spScore;
                            row.cqsScore = project.cqsScore;
                        }
                        row.singleScore = project.score;
                        row.calibtrateScore = detail.calibrationResults+"%";
                        tableData.push(row);
                    })
                });
                this.tableData = tableData;
            }
        },
    }
</script>

<style scoped>

</style>
